document.addEventListener("DOMContentLoaded", (event) => {
  const data = JSON.parse(localStorage.genieLanding || '{}');

  const rerenderLanguage = () => {
    [...document.querySelectorAll('[data-t]')].map((item) => item.innerHTML = i18next.t(item.dataset.t));
    document.querySelectorAll('.langs').forEach(({ children }) => [...children].forEach((item) => item?.classList?.remove('active')));
    document.querySelectorAll('.langs').forEach((item) => item.querySelector(`.${data.lang}`)?.classList?.add('active'));
  }

  function updateHtmlDirection(lang) {
    const html = document.documentElement;

    html.setAttribute('dir', lang === 'AR' ? 'rtl' : 'ltr');

    document.querySelectorAll('.langs.customSelect .selectDropdown')
      .forEach((el) => el.setAttribute('dir', lang === 'AR' ? 'rtl' : 'ltr'));

    html.setAttribute('lang', lang);
  }

  document.querySelectorAll('.selectLanguage').forEach((el) => el.addEventListener('click', () => {
    el.parentNode.classList.toggle('active');
    el.setAttribute(
      'aria-expanded',
      positionSelectButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
    );
  }));

  document.querySelectorAll('.langs.customSelect ul li input[type="radio"]').forEach((input) => {
    function handleChangeLanguage(e) {
      if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
        document.querySelectorAll('.langs.customSelect .selectLanguage .selectedLanguage')
          .forEach(el => el.textContent = input.id);
        document.querySelectorAll('.langs.customSelect').forEach((el) => el.classList.remove('active'));

        data.lang = input.id;
        localStorage.genieLanding = JSON.stringify(data);

        i18next.changeLanguage(data.lang);
        rerenderLanguage();
        updateHtmlDirection(input.id)
        document.dispatchEvent(new CustomEvent('languageChanged'));
      }
    }

    input.addEventListener('click', handleChangeLanguage);
  });

  document.querySelector('.menuButton').addEventListener('click', ({ currentTarget }) => {
    currentTarget.classList.toggle('active');
    document.querySelector('.menuMobile').classList.toggle('active');
  });

  document.querySelectorAll('.menuMobile > a, .menuMobile .en, .menuMobile .ru').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelector('.menuMobile').classList.toggle('active');
      document.querySelector('.menuButton').classList.toggle('active');
    })
  });

  window.addEventListener('load', rerenderLanguage);
});
